import { Component, Inject } from '@angular/core';
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@Component({
  selector: 'sign-up',
  template: `
    <div class="page thank-you">
      <div class="container text-center">
        <h1>{{ 'auth.thank_you.title' | translate }}</h1>
        <h3>{{ 'auth.thank_you.subtitle' | translate }}</h3>
      </div>
    </div>
  `,
})
export class ThankYouComponent {
  constructor(@Inject('$rootScope') private $rootScope: any) {}
}

((window as any).xplenty as angular.IModule).directive(
  'thankYou',
  downgradeComponent({
    component: ThankYouComponent,
  }),
);
